import { useContext, useMemo } from 'react'
import { RADashboardLayoutContext } from '.'

export function usePortfolioAssetClass() {
  const context = useContext(RADashboardLayoutContext)
  return context.assetClass;
}

// Custom hooks for using the layout context
export function useDashboardLayout() {
  const context = useContext(RADashboardLayoutContext)
  return context.layout;
}

export function useTabsInformation() {
  const layout = useDashboardLayout();
  const { initialTab, tabLayouts, tabSettings, tabsOrder } = layout;
  const tabInfo = useMemo(() => {
    return {
      order: tabsOrder,
      initialTab,
      layouts: tabLayouts,
      settings: tabSettings
    }
  }, [initialTab, tabLayouts, tabSettings, tabsOrder])
  return tabInfo;
}

export function useCardsInformation() {
  const layout = useDashboardLayout();
  const {tabLayouts, cardSettings } = layout;
  const tabInfo = useMemo(() => {
    return {
      layouts: tabLayouts,
      settings: cardSettings
    }
  }, [tabLayouts, cardSettings])
  return tabInfo;
}